import { render, staticRenderFns } from "./EmailSettingsChoiceTab.vue?vue&type=template&id=7ba42e15&scoped=true&"
import script from "./EmailSettingsChoiceTab.vue?vue&type=script&lang=js&"
export * from "./EmailSettingsChoiceTab.vue?vue&type=script&lang=js&"
import style0 from "./EmailSettingsChoiceTab.vue?vue&type=style&index=0&id=7ba42e15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba42e15",
  null
  
)

export default component.exports